import type { ReactNode } from 'react'
import cx from 'classnames'
import styles from './ErrorBlock.module.css'
import { extractMessageFromError } from '@/utils/error-util'
import { IconButton } from '@/components/IconButton'
import { Icon } from '@/components/Icon'
import { Button } from '@/components/Button'

interface ErrorBlockProps {
  error?: unknown
  children?: ReactNode
  onClose?: () => unknown
  onRetry?: () => unknown
  tackOn?: 'top' | 'bottom'
}

/**
 * An inline error message, optionally attached to the edge of the element
 * above or below it.
 */
export function ErrorBlock({
  error,
  children,
  tackOn,
  onClose,
  onRetry,
}: ErrorBlockProps) {
  return (
    <div className={cx(styles.root, tackOn ? styles[tackOn] : styles.default)}>
      <div className={styles.icon}>
        <Icon name="info" rotate={180} />
      </div>
      <div className={styles.content}>
        {!!error && extractMessageFromError(error)}
        {children}
      </div>
      {onRetry && (
        <div className={styles.actions}>
          <Button
            label="Try again"
            flat
            variant="destructive"
            onPress={onRetry}
          />
        </div>
      )}
      {onClose && (
        <div className={styles.actions}>
          <IconButton name="close" label="Dismiss" onPress={onClose} />
        </div>
      )}
    </div>
  )
}
